<template>
  <b-badge :variant="variant" v-b-tooltip.hover :title="longStatus">
    {{ short ? shortStatus : longStatus }}
  </b-badge>
</template>

<script>
import { capitalize, abbreviate } from '@/helpers';

export default {
  name: 'CandleStatusBadge',
  props: {
    status: {
      type: String,
      required: true,
    },
    testing: {
      type: String,
    },
    short: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    variant() {
      return this.variants[this.status];
    },
    longStatus() {
      return this.testing?.length > 0 ? this.testing : capitalize(this.status);
    },
    shortStatus() {
      return this.longStatus.split(', ').map((s) => abbreviate(s)).join(', ');
    },
  },
  data() {
    return {
      variants: {
        new: 'secondary',
        testing: 'warning',
        production: 'success',
        discarded: 'danger',
      },
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
